<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center">
        2020 - {{ Year }} &copy;
      </div>
    </div>
  </div>
</footer>
